"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performActionOnIssueBatchWithRetry = void 0;
var _without = _interopRequireDefault(require("lodash/without"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * This function will automatically retry any server failure once, and will parse the
 * problematic issues out of a failed response and do the retry without those issues,
 * and return data about which issues failed to be acted upon to the caller.
 *
 * This function is built to work for both edit and delete,
 * by using the parameters `asyncAction` instead
 * of hardcoding them for each of edit and delete and duplicating all this logic
 */
const performActionOnIssueBatchWithRetry = async _ref => {
  let {
    batch,
    asyncAction
  } = _ref;
  let responseData = undefined;
  const failureInfo = [];
  try {
    responseData = await asyncAction({
      issueUids: batch
    });
  } catch (e) {
    console.error("performActionOnIssueBatchWithRetry failed first attempt with error", e);
    let batchFailedIssueUids = [];
    if (e && e.details && e.details.length && e.details.map) {
      batchFailedIssueUids = e.details.map(detail => {
        const issueUid = detail.issue;
        failureInfo.push({
          issueUid,
          statusCode: e.status
        });
        return issueUid;
      });
    }
    try {
      const retryIssueUids = (0, _without.default)(batch, ...batchFailedIssueUids);
      if (retryIssueUids.length) {
        responseData = await asyncAction({
          issueUids: retryIssueUids
        });
      }
    } catch (e2) {
      console.error("performActionOnIssueBatchWithRetry failed second attempt with error", e2);
      batch.map(issueUid => {
        failureInfo.push({
          issueUid,
          statusCode: e2.status
        });
      });
    }
  }
  // if things went well, responseData will be a list of issues (for editing)
  // otherwise, it may be undefined
  return {
    batch,
    responseData,
    failureInfo
  };
};
exports.performActionOnIssueBatchWithRetry = performActionOnIssueBatchWithRetry;
//# sourceMappingURL=issuesCollection.bulkActionsHelpers.js.map